<template>
  <div class="list custom-scrollbar" :style="{maxHeight: maxHeight}">
    <div v-for="(item, key) in items" v-bind:key="key"
    class="columns is-vcentered is-multiline is-mobile">
      <div class="column is-narrow">
        <div class="list__dot" v-text="key + 1"></div>
      </div>
      <div class="column">
        <div class="list__text" v-text="item"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: String,
      default: 'auto',
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  .columns {
    border-bottom: 1px solid #eee;
  }
  &__dot {
    width: auto;
    height: auto;
    background-color: #2297cd;
    padding: 0.1rem 0.5rem;
    font-size: 1rem;
    border-radius: 2px;
    color: #ffffff;
  }
  &__text {
  }
}
</style>
